import { createApp } from 'vue'
import App from './App.vue'
import 'materialize-css/dist/css/materialize.min.css'
import 'material-design-icons/iconfont/material-icons.css'
import {makeRouter} from "@/router";

createApp(App)
    .use(makeRouter())
    .mount('#app')
